

export default {
    namespaced: true,
    state: {
        search: {}
    },
    mutations: {
        SET_SEARCH(state, data){
            state.search = data
        }
    },
    actions: {
        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/shop.js